var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sales-report__wrapper" }, [
    _c("div", { staticClass: "css-grid sales-report__header" }, [
      _c("div", { staticClass: "sales-report__header-name" }, [
        _vm._v(_vm._s(_vm.ucFirst(_vm.vendor.vendor)))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "css-grid sales-vendor-view__container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "css-grid sales-vendor-view__row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--current"
            },
            [
              _c(
                "div",
                { staticClass: "sales-vendor-view__category-subtitle" },
                [_vm._v("Active")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sales-vendor-view__category-value" }, [
                _vm._v(_vm._s(_vm.currency(_vm.vendor.units)))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--prior"
            },
            [
              _c(
                "div",
                { staticClass: "sales-vendor-view__category-subtitle" },
                [_vm._v("Runrate")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sales-vendor-view__category-value" }, [
                _vm._v(_vm._s(_vm.currency(_vm.vendor.est_units)))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--change",
              attrs: {
                "data-toggle": "tooltip",
                title:
                  "Runrate vs. Prior " + this.currency(_vm.vendor.yoy_units)
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "sales-vendor-view__category-value",
                  class: [
                    _vm.getChangePercent(
                      _vm.vendor.est_units,
                      _vm.vendor.yoy_units
                    ) >= 0
                      ? "sales-vendor-view__category-value--positive"
                      : "sales-vendor-view__category-value--negative"
                  ]
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.getChangePercent(
                          _vm.vendor.est_units,
                          _vm.vendor.yoy_units
                        )
                      ) +
                      "%\n          "
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--current"
            },
            [
              _c(
                "div",
                { staticClass: "sales-vendor-view__category-subtitle" },
                [_vm._v("Active")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sales-vendor-view__category-value" }, [
                _vm._v("$" + _vm._s(_vm.currency(_vm.vendor.sales)))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--prior"
            },
            [
              _c(
                "div",
                { staticClass: "sales-vendor-view__category-subtitle" },
                [_vm._v("Runrate")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sales-vendor-view__category-value" }, [
                _vm._v("$" + _vm._s(_vm.currency(_vm.vendor.est_sales)))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--change",
              attrs: {
                "data-toggle": "tooltip",
                title:
                  "Runrate vs. Prior $" + this.currency(_vm.vendor.yoy_sales)
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "sales-vendor-view__category-value",
                  class: [
                    _vm.getChangePercent(
                      _vm.vendor.est_sales,
                      _vm.vendor.yoy_sales
                    ) >= 0
                      ? "sales-vendor-view__category-value--positive"
                      : "sales-vendor-view__category-value--negative"
                  ]
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.getChangePercent(
                          _vm.vendor.est_sales,
                          _vm.vendor.yoy_sales
                        )
                      ) +
                      "%\n          "
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--current"
            },
            [
              _c(
                "div",
                { staticClass: "sales-vendor-view__category-subtitle" },
                [_vm._v("Active")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sales-vendor-view__category-value" }, [
                _vm._v(
                  "$" +
                    _vm._s(
                      _vm.currency(
                        _vm.divide(_vm.vendor.sales, _vm.vendor.units)
                      )
                    )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--prior"
            },
            [
              _c(
                "div",
                { staticClass: "sales-vendor-view__category-subtitle" },
                [_vm._v("Prior")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sales-vendor-view__category-value" }, [
                _vm._v(
                  "$" +
                    _vm._s(
                      _vm.currency(
                        _vm.divide(_vm.vendor.yoy_sales, _vm.vendor.yoy_units)
                      )
                    )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--change"
            },
            [
              _c(
                "div",
                {
                  staticClass: "sales-vendor-view__category-value",
                  class: [
                    _vm.getChangePercent(
                      _vm.divide(_vm.vendor.sales, _vm.vendor.units),
                      _vm.divide(_vm.vendor.yoy_sales, _vm.vendor.yoy_units)
                    ) >= 0
                      ? "sales-vendor-view__category-value--positive"
                      : "sales-vendor-view__category-value--negative"
                  ]
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.getChangePercent(
                          _vm.divide(_vm.vendor.sales, _vm.vendor.units),
                          _vm.divide(_vm.vendor.yoy_sales, _vm.vendor.yoy_units)
                        )
                      ) +
                      "%\n          "
                  )
                ]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "css-grid sales-report__footer" },
      [
        _c("SalesDetails", {
          attrs: {
            months: _vm.vendorData,
            show: _vm.displayDetails,
            includeHeader: false
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "sales-report__footer--more",
            on: { click: _vm.toggleDetails }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMonths,
                    expression: "showMonths"
                  }
                ],
                staticClass: "sales-report__footer-expandable"
              },
              [
                _vm._v(
                  _vm._s(_vm.displayDetails ? "- Show less" : "+ Show details")
                )
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid sales-vendor-view__row sales-vendor-view__row--header"
      },
      [
        _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--header"
            },
            [_vm._v("All")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--header"
            },
            [_vm._v("Units")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--header"
            },
            [_vm._v("Sales")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
          _c(
            "div",
            {
              staticClass:
                "sales-vendor-view__cell sales-vendor-view__cell--header"
            },
            [_vm._v("ASP")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "css-grid sales-vendor-view__category" }, [
      _c(
        "div",
        {
          staticClass: "sales-vendor-view__cell sales-vendor-view__cell--totals"
        },
        [
          _c("div", { staticClass: "sales-vendor-view__category-value" }, [
            _vm._v("Totals")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }